import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux'
import { HashRouter, Navigate, Route, Routes, createRoutesFromElements } from "react-router-dom";
import { Store, persistor } from './store';
import { createHashRouter, RouterProvider} from "react-router-dom";

import './index.css';
import { GlobalFonts } from 'senac-components';
import { WPageBookFiltered } from './components/WPageBookFiltered';
import { WPageShowcase, WReader, WPageBookDetail, WPageBookSummary, WPageBookFound, WPageHome, WPageLogin, WPageForgotMyPassword, WPageSelectOrganization, WPagePassword, WPageRecoverPassword, WPageChangeYourPassword, WPageProfile, WPageTermsOfUse, WPageContactUs, WPageFAQ, WPageRegister, WPageBookReadingList, WPageLibraryFavorite, WPageLibrarySection, WPageLibraryReadingList, WPageLibraryReadingListCard, WPageOffline } from './components';
import { WPageHelp } from './components/WPageHelp';
import { WPlayer } from './components/WPlayer';
import { WPageAppointments } from './components/WPageAppointments';
import { WPageLibraryAppointments } from './components/WPageLibraryAppointments';
import { WPageLibraryDownload } from './components/WPageLibraryDownload';
import { ManagementContentDetail } from './components/ManagementContentDetail';
import { WPageAbout } from './components/WPageAbout';
import { WPagePrivacyPolice } from './components/WPagePrivacyPolice';
import { Wsso } from './components/Wsso';
import { WssoV2 } from './components/WssoV2';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const router = createHashRouter
(
  createRoutesFromElements
  (
    <Route path="/" element={<App/>}>
      <Route path="inicio" element={<WPageShowcase />} />
      <Route path="reader/:id" element={<WReader />} />
      <Route path="content/uid/:contentUid" element={<ManagementContentDetail/>}>
        <Route path="detail" element={<WPageBookDetail />}/>
        <Route path="summary" element={<WPageBookSummary />}/>
        <Route path="readinglist" element={<WPageBookReadingList />}/>
        <Route path="appointments" element={<WPageAppointments />}/>
      </Route>
      <Route path="library">
        <Route path="options" element={<WPageLibrarySection />}/>
        <Route path="downloads" element={<WPageLibraryDownload />}/>
        <Route path="favorites" element={<WPageLibraryFavorite />}/>
        <Route path="appointments" element={<WPageLibraryAppointments />}/>
        <Route path="readinglist" element={<WPageLibraryReadingListCard />}/>
        <Route path="readinglist/uid/:listUid" element={<WPageLibraryReadingList />}/>
      </Route>
      <Route path="recover-password" element={<WPageRecoverPassword />} />
      <Route path="user">
        <Route path="options" element={<WPageHome />} />
        <Route path="login" element={<WPageLogin/>} />
        <Route path="forgot" element={<WPageForgotMyPassword />} />
        <Route path="projects" element={<WPageSelectOrganization />} />
        <Route path="password" element={<WPagePassword />} />
        <Route path="recover" element={<WPageRecoverPassword />} />
        <Route path="change" element={<WPageChangeYourPassword />} />
        <Route path="profile" element={<WPageProfile />} />
        <Route path="register" element={<WPageRegister />} />
      </Route>
      <Route path="search">
        <Route path="metadata" element={<WPageBookFound />}/>
        <Route path="category/uid/:categoryUid" element={<WPageBookFiltered />}/>
      </Route>
      <Route path="offline" element={<WPageOffline/>}/>
      <Route path="content/reference/uid/:contentReferenceUid/player" element={<WPlayer />}/>
      <Route path="help" element={<WPageHelp />} />
      <Route path="terms" element={<WPageTermsOfUse />} />
      <Route path="privacy" element={<WPagePrivacyPolice />} />
      <Route path="contact" element={<WPageContactUs />} />
      <Route path="faq" element={<WPageFAQ />} />
      <Route path="about" element={<WPageAbout />} />
      <Route path="sso/:organization/:login/:token" element={<Wsso />} />
      <Route path="sso/v3/:connector/:valueType/:value/:state" element={<WssoV2 />} />
      <Route path="*" element={<Navigate to={"/"} replace={true} />} />
    </Route>
  )
);

root.render(
  <React.StrictMode>
    <Provider store={Store} >
        <GlobalFonts/>
        <RouterProvider router={router} />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
